(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  L.Draw.BetterCircle = (function(superClass) {
    extend(BetterCircle, superClass);

    function BetterCircle() {
      this._hasAncestor = bind(this._hasAncestor, this);
      this._onMouseMove = bind(this._onMouseMove, this);
      return BetterCircle.__super__.constructor.apply(this, arguments);
    }

    BetterCircle.prototype._getRadiusText = function() {
      if ((this.options.units != null) && this.options.units === 'english') {
        return (this._shape.getRadius() * 3.28084).toFixed(1) + ' ft';
      }
      return this._shape.getRadius().toFixed(1) + ' m';
    };

    BetterCircle.prototype._onMouseMove = function(e) {
      var radius;
      this._tooltip.updatePosition(e.latlng);
      if (this._isDrawing) {
        this._drawShape(e.latlng);
        radius = this._getRadiusText();
        return this._tooltip.updateContent({
          text: this._isCurrentlyTwoClickDrawing ? 'Click again to finish drawing' : 'Release mouse to finish drawing.',
          subtext: 'Radius: ' + radius
        });
      }
    };

    BetterCircle.prototype._hasAncestor = function(el, cls) {
      while (!el.classList.contains(cls)) {
        el = el.parentElement;
        if (!el) {
          break;
        }
      }
      return el;
    };

    BetterCircle.prototype._onMouseUp = function(e) {
      if (!this._shape && !this._isCurrentlyTwoClickDrawing) {
        this._isCurrentlyTwoClickDrawing = true;
        return;
      }
      if (this._isCurrentlyTwoClickDrawing && !this._hasAncestor(e.target, 'leaflet-map-pane')) {
        return;
      }
      if (this._shape) {
        this._fireCreatedEvent();
        this.disable();
        if (this.options.repeatMode) {
          return this.enable();
        }
      }
    };

    BetterCircle.prototype._onMouseDown = function(e) {
      this._isDrawing = true;
      if (!this._isCurrentlyTwoClickDrawing) {
        this._startLatLng = e.latlng;
      }
      return L.DomEvent.on(document, 'mouseup', this._onMouseUp, this).on(document, 'touchend', this._onMouseUp, this).preventDefault(e.originalEvent);
    };

    return BetterCircle;

  })(L.Draw.Circle);

}).call(this);
